import axios from "axios";

const baseURL = process.env.VUE_APP_DIRECTUS_URL;
const token = process.env.VUE_APP_DIRECTUS_TOKEN;

if (!baseURL) {
  console.error("❌ VUE_APP_DIRECTUS_URL is missing");
}

const directus = axios.create({
  baseURL,
  headers: token
    ? { Authorization: `Bearer ${token}` }
    : {},
});

/* ---------------- AUTO STATUS FILTER ---------------- */

directus.interceptors.request.use((config) => {
  const isTest = window.location.pathname.startsWith("/test");

  // Only modify if request has params
  if (config.params) {
    if (!config.params.filter) {
      config.params.filter = {};
    }

    // Only inject if status not already defined
    if (!config.params.filter.status) {
      config.params.filter.status = isTest
        ? { _in: ["active", "test"] }
        : { _eq: "active" };
    }
  }

  return config;
});

export default directus;